import React, { useState, useEffect } from "react"; // eslint-disable-line no-unused-vars
import { Collection } from "../components";
import { getSearchResults } from "../../../shared/utilities/actions";
import { SearchResult, Query, DefaultQuery } from "../../../shared/types";
import { Button, Grid2 as Grid, LinearProgress } from "@mui/material";

export interface MainProps {}

export const Main = (props: MainProps): React.JSX.Element => {
  const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
  const [query, setQuery] = useState<Query>({ ...DefaultQuery });
  const [busy, setBusy] = useState<boolean>(false);
  const [showMore, setShowMore] = useState<boolean>(false);

  const fetchSearchResults = async (query: Query) => {
    setBusy(true);
    let searchResultsResponse: SearchResult[] = await getSearchResults(query);
    setShowMore(searchResultsResponse.length == query.size);
    setSearchResults([...searchResults, ...searchResultsResponse]);
    setBusy(false);
  };

  useEffect(() => {
    if (query.text) {
      fetchSearchResults(query);
    }
  }, [query]);

  useEffect(() => {
    setBusy(true);
    let params = new URLSearchParams(document.location.search);
    let queryParameterText = params.get("text");
    let queryParameterCat = params.get("cat");
    let queryParameterRange = params.get("range");
    let queryParameterLat = params.get("latitude");
    let queryParameterLon = params.get("longitude");
    let queryParameterSize = params.get("size");
    let queryParameterSkip = params.get("skip");

    setQuery({
      text: queryParameterText ? queryParameterText : "",
      category: queryParameterCat ? queryParameterCat : "",
      range: queryParameterRange ? parseInt(queryParameterRange) : 0,
      latitude: queryParameterLat ? parseFloat(queryParameterLat) : 0,
      longitude: queryParameterLon ? parseFloat(queryParameterLon) : 0,
      size: queryParameterSize ? parseInt(queryParameterSize) : 50,
      skip: queryParameterSkip ? parseInt(queryParameterSkip) : 0,
    });
    setBusy(false);
  }, []);

  return (
    <Grid size={{ xs: 12 }} container sx={{ marginTop: "24px" }}>
      <Grid size={{ xs: 12 }}>{busy && <LinearProgress />}</Grid>
      {!busy && (
        <Collection
          searchResults={searchResults}
          handleSelect={(ein: string) => {
            setBusy(true);
            window.location.href = `/charity/?charityId=${ein}`;
          }}
        />
      )}
      {showMore && (
        <Grid size={{ xs: 12 }} textAlign="center" sx={{ paddingTop: "16px" }}>
          <Button
            disabled={busy}
            variant="outlined"
            className="tb_action_button"
            onClick={() => {
              let newQuery = { ...query, skip: query.skip + query.size };
              setQuery(newQuery);
            }}
          >
            Show More Charities
          </Button>
        </Grid>
      )}
    </Grid>
  );
};
